/**
 * Flattens the pages of a `useInfiniteQueryUntilEnd` reference-data query into
 * an ID → name lookup. Keyed by number because the lookup services return
 * numeric IDs while the app's own types carry them as strings.
 */
export const nameMapFrom = (
  pages: {results: {ID: string; name: string}[]}[] | undefined,
): Map<number, string> =>
  new Map(
    (pages ?? []).flatMap((page) =>
      page.results.map((record): [number, string] => [
        Number(record.ID),
        record.name,
      ]),
    ),
  )
